<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import TableLoading from "@/components/ipos/table-loading";
import { accountService } from "@/services/authservice/account";
import { accountantService } from "@/services/authservice/accountant";
import UtilsMixin from "@/mixins/utils";

function initialState() {
  return {
    title: "Thanh toán công nợ giao hàng",
    items: [
      {
        text: "Trang chủ",
        href: "/",
      },
      {
        text: "Công nợ giao hàng",
        active: true,
      },
      {
        text: "Thanh toán công nợ",
        active: true,
      },
    ],
    type: "shipper",
    listShipper: [],
    listChildTargetAll: [],
    listChildTarget: [],
    formData: {
      shipper: "",
      payTime: "",
      payTotal: 0,
      totalDebtAmount: 0,
      note: "",
    },
    isBusy: true,
    isBtnLoading: false,
    submitted: false,
    isLoadingSearch: false,
    listPO: [],
    isLoadDebt: false
  };
}

export default {
  page: {
    title: "Thanh toán công nợ giao hàng",
    meta: [{ name: "description", content: appConfig.description }],
  },
  mixins: [UtilsMixin],
  components: { Layout, PageHeader, Multiselect, DatePicker, TableLoading },
  data: initialState,

  beforeMount() {
    this.getInitData();
  },

  methods: {
    async getInitData() {
      this.isBusy = true;
      // get list shipper
      const resShipper = await accountService.getList({ role_id: "SHIPPER" });
      if (resShipper.data.error) {
        this.listShipper = [];
      } else {
        this.listShipper = resShipper.data.data;
      }
      this.formData.payTime = new Date();
      this.isBusy = false;
    },

    async onChangeTarget(value) {
      this.formData.payTotal = 0;
      this.formData.payTime = new Date();
      this.listChildTarget = [];
      this.isLoadDebt = true
      const res = await accountantService.billDebtV2(this.type, {
        shipper_id: value.email,
      });
      if(res.data){
        const list = [];
        res.data.data.forEach((e) => {
          e.shipper_debt_amount = e.total_amount;
          list.push(e);
        });
        this.listChildTargetAll = list;
        this.listChildTarget = this.listChildTargetAll
        this.listChildTarget.sort((a, b) =>
            a.payment_time > b.payment_time
                ? 1
                : b.payment_time > a.payment_time
                ? -1
                : 0
        );
      }else {
        this.$notify({
          group: "app",
          type: "error",
          text: res.error.message,
        });
      }
      this.calculateTotalDebtAmount();
      this.calculateTotalPayCollectAmount();
      this.isLoadDebt = false
    },

    calculateTotalDebtAmount() {
      this.formData.totalDebtAmount = this.listChildTargetAll.reduce(
        (totalAmount, item) => {
          return totalAmount + item.shipper_debt_amount;
        },
        0
      );
    },

    calculateTotalPayCollectAmount() {
      this.formData.payTotal = this.listChildTarget.reduce(
          (totalAmount, item) => {
            return totalAmount + item.shipper_debt_amount;
          },
          0
      );
    },

    showListPO(data) {
      this.listPO = data.details ? data.details : [];
      this.$bvModal.show("md-crud");
    },

    removeItem(index) {
      this.listChildTarget.splice(index, 1)
      this.calculateTotalPayCollectAmount();
    },

    async onPay() {
      const list_id = this.listChildTarget.map(function (e){
        return e.id
      })
      this.isBtnLoading = true;
      const res = await accountantService.cancelRemittanceAdvice({
        status: 'COMPLETED',
        list_id
      });
      if (res.data.error) {
        this.$notify({
          group: "app",
          type: "error",
          title: "Thanh toán lỗi",
          text: res.data.error.message,
        });
      } else {
        this.$notify({
          group: "app",
          type: "success",
          title: "Thanh toán thành công",
        });
        this.resetData();
      }
      this.isBtnLoading = false;
    },

    onConfirm() {
      let isValidTotal = true;
      isValidTotal = this.formData.totalDebtAmount - this.formData.payTotal >= 0;
      if (isValidTotal) {
        if (
          this.formData.shipper &&
          this.formData.payTotal &&
          this.formData.payTime
        ) {
          this.$bvModal.show("md-confirm");
        } else {
          this.$notify({
            group: "app",
            type: "error",
            title: "Nhập đầy đủ thông tin",
            text: "Vui lòng nhập đầy đủ thông tin",
          });
        }
      } else {
        this.$notify({
          group: "app",
          type: "error",
          title: "Vui lòng kiểm tra lại tổng tiền",
        });
      }
    },

    hideModal() {
      this.$bvModal.hide("md-confirm");
    },
    resetData() {
      Object.assign(this.$data, initialState());
      this.getInitData();
      this.$bvModal.hide("md-confirm");
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" style="margin-left: -5px; margin-right: -5px">
      <div
        class="col-lg-12 col-md-12 col-sm-12 mb-2"
        style="padding-left: 5px; padding-right: 5px"
      >
        <div class="bg-white box-shadow" style="border: 1px solid #eff2f7">
          <TableLoading v-if="isBusy" />
          <template v-else>
            <div class="bg-white p-3">
              <div class="input-no-br">
                <div class="d-flex mtn1">
                  <div class="custom-input-group w200">Giao hàng</div>
                  <multiselect
                    id="address"
                    v-model="formData.shipper"
                    :options="listShipper"
                    track-by="id"
                    label="name"
                    placeholder="Chọn giao hàng"
                    noOptions="Danh sách trống"
                    :show-labels="false"
                    class="custom-multi-select"
                    @input="onChangeTarget"
                  ></multiselect>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Tổng công nợ" class="w200">
                    <b-input
                      type="text"
                      :disabled="true"
                      :value="formatPrice(formData.totalDebtAmount)"
                    ></b-input>
                  </b-input-group>
                </div>
                <div class="d-flex mtn1">
                  <div class="custom-input-group" style="min-width: 200px">
                    Thời gian thanh toán
                  </div>
                  <date-picker
                    type="date"
                    id="requireTime"
                    v-model="formData.payTime"
                    :first-day-of-week="1"
                    lang="vi"
                    format="DD/MM/YYYY"
                    placeholder="Chọn thời gian"
                    class="custom-datepicker"
                  ></date-picker>
                </div>
                <div class="d-flex mtn1">
                  <b-input-group prepend="Số tiền thanh toán" class="w200">
                    <b-input
                      type="text"
                      v-currency="{
                        precision: 0,
                        currency: null,
                        valueAsInteger: true,
                        distractionFree: false,
                      }"
                      disabled
                      :value="formatPrice(formData.payTotal)"
                    ></b-input>
                  </b-input-group>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div
        class="col-lg-12 col-md-12 col-sm-12 mb-2"
        style="padding-left: 5px; padding-right: 5px"
      >
        <div class="table-responsive mb-2 bg-white box-shadow">
          <TableLoading v-if="isBusy || isLoadDebt" />
          <table class="table table-bordered scroll-table" v-else>
            <thead>
              <tr>
                <th scope="col">Mã chứng từ</th>
                <th scope="col">Ngày chứng từ</th>
                <th scope="col">Mã khách hàng</th>
                <th scope="col">Khách hàng</th>
                <th scope="col">Tiền thanh toán</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in listChildTarget" :key="item.id">
                <td>
                  <b-button
                    v-if="item.details && item.details.length > 0"
                    class="p-0"
                    variant="link"
                    @click="showListPO(item)"
                    >{{ item.payment_id }}</b-button
                  >
                  <span v-else>{{ item.payment_id }}</span>
                </td>
                <td>{{ formatDateUnix(item.payment_time) }}</td>
                <td>{{ item.payer_id }}</td>
                <td>{{ item.payer_name }}</td>
                <td>{{ formatPrice(Math.abs(item.shipper_debt_amount)) }}</td>
                <td class="text-center">
                  <i
                    @click="removeItem(index)"
                    class="bx bx-x-circle font-size-16 text-danger ipos-pointer"
                  ></i>
                </td>
              </tr>
              <tr v-if="listChildTarget.length === 0">
                <td colspan="6">
                  <p class="p-3 m-0 text-center">Chưa có dữ liệu</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="table-responsive mb-0 bg-white box-shadow">
          <TableLoading v-if="isBusy" />
          <div v-else class="p-3" style="border: 1px solid #eff2f7">
            <div
              class="d-flex align-content-center justify-content-between"
            >
              <p class="font-weight-bold">Dư nợ sau thanh toán</p>
              <p class="font-weight-bold">
                {{ formatPrice(formData.totalDebtAmount - formData.payTotal,true) }}
              </p>
            </div>
<!--            <div class="d-flex align-content-center justify-content-between">-->
<!--              <b-input-->
<!--                class="mb-3"-->
<!--                type="text"-->
<!--                id="note"-->
<!--                v-model="formData.note"-->
<!--                placeholder="Ghi chú (nếu có)"-->
<!--              ></b-input>-->
<!--            </div>-->
            <div class="d-flex align-content-center justify-content-end">
              <button
                class="btn btn-primary w-md d-block"
                type="submit"
                @click="onConfirm()"
                v-bind:disabled="isBtnLoading"
              >
                <template v-if="isBtnLoading">
                  <i
                    class="bx bx-loader bx-spin font-size-16 align-middle mr-2"
                  ></i>
                  Đang xử lý...
                </template>
                <template v-else>Thanh toán</template>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Xác nhận tiếp tục thanh toán công nợ -->
      <b-modal id="md-confirm" title="Xác nhận thanh toán" centered hide-footer>
        <p>
          Thanh toán <b>{{ formatPrice(listChildTarget.length) }}</b> đơn hàng cho giao hàng
          <b>{{ formData.shipper ? formData.shipper.name : "" }}</b> với tổng số
          tiền là <b>{{ formatPrice(formData.payTotal,true) }}</b>
        </p>
        <footer class="modal-footer px-0 pb-0">
          <button type="button" class="btn btn-secondary" @click="hideModal">
            Quay lại
          </button>
          <button type="button" class="btn btn-primary" @click="onPay">
            <template v-if="isBtnLoading">
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle mr-2"
              ></i>
              Đang xử lý...
            </template>
            <template v-else>Xác nhận</template>
          </button>
        </footer>
      </b-modal>

      <!-- Modal chi tiết danh sách đơn PO -->
      <b-modal
        id="md-crud"
        title="Danh sách đơn hàng"
        size="lg"
        centered
        hide-footer
      >
        <table class="table table-bordered scroll-table">
          <thead>
            <tr>
              <th scope="col">Mã đơn hàng</th>
              <th scope="col">Ngày đơn hàng</th>
              <th scope="col">Mã khách hàng</th>
              <th scope="col">Khách hàng</th>
              <th scope="col">Tiền đã thu</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in listPO" :key="item.id">
              <td>
                <router-link
                  target="_blank"
                  :to="{ name: 'OrderDetail', params: { id: item.po_uid } }"
                >
                  {{ item.po_id }}
                </router-link>
              </td>
              <td>{{ formatDateUnix(item.po_date) }}</td>
              <td>{{ item.customer_id }}</td>
              <td>{{ item.customer_name }}</td>

              <td>{{ formatPrice(Math.abs(item.payment_amount)) }}</td>
            </tr>
            <tr v-if="listPO.length === 0">
              <td colspan="6">
                <p class="p-3 m-0 text-center">Không có dữ liệu</p>
              </td>
            </tr>
          </tbody>
        </table>
      </b-modal>
    </div>
  </Layout>
</template>